import { FC } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import __ from "src/utils/Translations";
import Spinner from "src/Components/Spinner";

import { useFetchSubscription } from "./query";
import SubscriptionBenefitsDetails from "./SubscriptionBenefitsDetails";
import SubscriptionBenefitsPaymentsPeriods from "./SubscriptionBenefitsPaymentsPeriods";

interface Props {
  subscriptionId: string;
  open: boolean;
  onClose: () => void;
}

const SubscriptionBenefitsPreview: FC<Props> = ({
  subscriptionId,
  open,
  onClose,
}) => {
  const {
    data: details,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useFetchSubscription(subscriptionId);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      maxWidth={false}
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "80vw",
          padding: 2,
          borderRadius: 2,
          boxSizing: "border-box",
        },
      }}
    >
      <DialogTitle sx={{ mt: 2, mb: 2 }}>
        {__("Szczegóły świadczenia")} {subscriptionId}
      </DialogTitle>
      <DialogContent>
        {isError && (
          <Alert variant="outlined" color="warning">
            {String(error)}
          </Alert>
        )}
        {isLoading && (
          <Stack
            direction="row"
            sx={{
              height: 280,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {Spinner}
          </Stack>
        )}
        {isSuccess && (
          <SubscriptionBenefitsDetails details={details}>
            <SubscriptionBenefitsPaymentsPeriods
              subscriptionId={subscriptionId}
            />
          </SubscriptionBenefitsDetails>
        )}
      </DialogContent>
      <DialogActions disableSpacing>
        <Button onClick={onClose}>{__("Zamknij")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionBenefitsPreview;
